export default __webpack_public_path__ + "images/DJB.0375eec.png";